import { routerStyxie } from '@/router/styxieBridge'

// Client-side routed; the page fetches its rows over the API, so there is no payload to hydrate.
Styxie.Initializers.PostsDashboard = routerStyxie({ actions: ['index']})
